<template>
  <ul class="md:tw-grid md:tw-grid-cols-3 md:tw-gap-x-6 md:tw-gap-y-12">
    <li v-for="game in games" :key="game.id">
      <div
        @click="$emit('selectgame', game)"
        class="tw-cursor-pointer hover:tw-outline hover:tw-outline-2 hover:tw-outline-primary hover:tw-outline-offset-2"
      >
        <h3
          class="tw-bg-primary tw-text-mainbg1 tw-text-lg tw-font-medium tw-text-center tw-py-1"
        >
          {{ game.name }} 
        </h3>
        <div class="tw-aspect-video tw-w-full">
          <img
            :src="$filters.buildPath('/media/images/game_small_thumbs/' + game.id + '.png')"
            class="tw-w-full tw-h-full tw-object-cover"
          />
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { SfGame } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: { games: Object as PropType<SfGame[]> },
  emits: ["selectgame"],
});
</script>
